<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { BotIcon } from "lucide-vue-next";
import { newGuid } from "@/common/lib/string";
import { useJustCreatedAiNode } from "../ai/useJustCreatedAiNode";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps>();

const isJustCreated = useJustCreatedAiNode();
function run() {
  const id = newGuid();

  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .insertBelow(({ onlyIfEmpty: true }))
    .setAiNode({ id, text: "Let's chat", prompt: "", ask: "" })
    .run();

  isJustCreated.id.value = id;
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="BotIcon"
    @pointerdown.prevent
    @click="run"
    @keydown.enter="run"
  >
    <div class="flex items-center gap-2">
      <span>AI chat</span>
    </div>
  </SuggestionListItem>
</template>
